import React from "react";
import {BackgroundColorContext} from "../../contexts/BackgroundColorContext";
import useColorHandler from "../../hooks/ColorHandler";
import {getStoredUserColor} from "../../utils/userColor";

export default function BackgroundColorWrapper(props: {children: React.ReactNode}) {
  const {color, setColorStatus} = useColorHandler(getStoredUserColor());

  function changeColor(color: string) {
    setColorStatus(color);
  }

  return (
    <BackgroundColorContext.Provider value={{color: color, changeColor}}>
      {props.children}
    </BackgroundColorContext.Provider>
  );
}
